import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import * as globalActions from '../../actions/global';
import logoutImage from '../../assets/images/sign-out-solid.svg';

const Logout = () => {
  const dispatch = useDispatch();
  const auth0 = useAuth0();

  function handleLogout() {
    auth0.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
    dispatch(globalActions.logout());
  }

  return (
    <div className='logout'>
      <button
        className='link-button'
        onClick={handleLogout}
        style={{ color: 'white' }}
        type='button'
      >
        {window.innerWidth > 768 ? (
          'Logout'
        ) : (
          <img alt='Logout' src={logoutImage} />
        )}
      </button>
    </div>
  );
};

export default Logout;
